import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n/config";

// Avoid Google Translate
document.documentElement.setAttribute('translate', 'no');
const meta = document.createElement('meta');
meta.name = "google";
meta.content = "notranslate";
document.head.appendChild(meta);

const router = createBrowserRouter([
  {
    path: "/signup",
    element: <App/>,
  },
  {
    path: "/signup/confirm",
    element: <App/>,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleReCaptchaProvider
  reCaptchaKey={ process.env.REACT_APP_RECAPTCHA_SITE_KEY }
  scriptProps={{
    async: true,
    defer: true,
  }}>
    <React.StrictMode>
      <Provider store={ store }>
        <RouterProvider router={ router }/>
      </Provider>
    </React.StrictMode>
  </GoogleReCaptchaProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
